"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function jsNumberForAddress(address) {
    var addr = address.slice(2, 10);
    var seed = parseInt(addr, 16);
    return seed;
}
exports.default = jsNumberForAddress;
